import React, { useState, useEffect } from "react";
import { VsiH4, VsiHr, VsiLgText } from "../../styled/App.styled";
import { useVsiAppContext } from "../../stores/VsiApp";
import { useTitleFromComponent } from "../../utils/hooks";
import {
  Button,
  Spinner
} from "reactstrap";
import { shortDatePlusTimeFormatter, roleFormatter } from "../../utils/gridFormatters";
import { GetAuth } from "../../utils/Verbs";
import { useNavigate } from "react-router-dom";
import Grid from "../../components/Grid";

const allUsersDefs = [
  { field: "firstName", headerName: "First" },
  { field: "lastName", headerName: "Last" },
  {
    field: "client.name",
    headerName: "Company"
  },
  { field: "email", headerName: "Email" },
  {
    field: "lastLogin",
    headerName: "Last Login",
    cellRenderer: shortDatePlusTimeFormatter
  },
  {
    field: "role",
    headerName: "Role",
    cellRenderer: roleFormatter
  }
];

export default function Users({ title, roles }) {
  useTitleFromComponent(title);

  let navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(true);
  const [allUsers, setAllUsers] = useState([]);
  const { user, client, getAccessTokenSilently } = useVsiAppContext();

  // TODO get this working
  const setParentCompany = e => {
    console.log(3);
  };

  const addUserClick = () => {
    navigate("/user/settings/admin/users/add-user");
  };

  const editUser = (e) => {
    navigate(`/user/settings/admin/users/edit-user?user_id=${e.data._id}`);
  };

  useEffect(() => {
    const getUsers = async () => {
      const token = await getAccessTokenSilently();
      if (roles.includes(user.role) && title === "Users") {
        GetAuth(`/api/v6/admin/users/client/${client.clientId}`, token)
          .then(data => {
            setAllUsers(data.data);
            setIsLoading(false);
          })
          .catch(err => {
            console.error(err);
            setIsLoading(false);
          });
      } else if (roles.includes(user.role) && title === "All Users") {
        GetAuth("/api/v6/admin/users", token)
          .then(data => {
            setAllUsers(data.data);
            setIsLoading(false);
          })
          .catch(err => {
            console.error(err);
            setIsLoading(false);
          });
      } else {
        if (title === "Users") {
          navigate("/user/settings/admin/users");
        } else if (title === "All Users") {
          navigate("/user/settings/admin/client-users");
        } else {
          // Just to catch any unforeseen errors
          navigate("/home");
        }
      }
    }

    getUsers();
  }, []);

  return <div>
    <VsiH4>{title}</VsiH4>
    <VsiHr />
    <div className={"my-3"}>
      <Button color="success" onClick={addUserClick} disabled={isLoading}>
        Add User
      </Button>
      <VsiLgText className={"ms-2"}>* Double click a user to edit user details</VsiLgText>
    </div>
    {isLoading ? <Spinner color={"primary"} /> :
      <Grid data={allUsers} columnDefs={allUsersDefs} rowDoubleClicked={editUser} />
    }
  </div>;
}
